import React, { useState } from "react";
import styled from "styled-components";
import { isValid } from "postcode";
import {
  Card,
  CTAButton,
  Heading3,
  Margin,
  P,
  TextField,
  theme,
} from "@ovotech/element";
import { usePageContext } from "../../App";

const PostcodeRow = styled.div`
  padding: 0;
  display: flex;
  flex-direction: row;
`;

const PostcodeContainer = styled.div`
  display: flex;
  margin-top: ${theme.space[2]};
`;

const SubmitContainer = styled.div`
  display: flex;
  align-items: flex-end;
`;

interface FormField<T> {
  value: T;
  error: string;
}

interface PostcodeForm {
  postcode: FormField<string>;
}

function PostcodeCard() {
  const [form, setForm] = useState<PostcodeForm>({
    postcode: { value: "", error: "" },
  });
  const { setPostcode, setRegion } = usePageContext();

  async function onSubmit(event: React.FormEvent) {
    event.preventDefault();
    if (form.postcode.value.length === 0) {
      setForm({
        ...form,
        postcode: {
          ...form.postcode,
          error: "Enter postcode",
        },
      });
    } else {
      const valid = isValid(form.postcode.value);
      if (valid) {
        setPostcode(form.postcode.value);
        setRegion(null);
      } else {
        setForm({
          ...form,
          postcode: {
            ...form.postcode,
            error: "Enter a valid postcode",
          },
        });
      }
    }
  }

  return (
    <Card>
      <Heading3>Our plans & prices</Heading3>
      <P>
        We’ll use your postcode to find gas and/or electricity plan prices in
        your area. This includes multi-rate electricity meters like Economy 7.
        There are some available plans that you can’t buy online. You’ll also
        find energy prices for plans that aren’t available at the moment.
      </P>
      <form noValidate onSubmit={onSubmit}>
        <PostcodeRow>
          <PostcodeContainer>
            <TextField
              error={form.postcode.error}
              label="Your postcode"
              characters={12}
              onChange={(event) => {
                setForm({
                  ...form,
                  postcode: {
                    value: event.target.value.toUpperCase().replace(/ /g, ""),
                    error: "",
                  },
                });
              }}
              id="postcode"
            />
          </PostcodeContainer>
          <SubmitContainer>
            <Margin left={4}>
              <CTAButton type="submit">Find energy plans</CTAButton>
            </Margin>
          </SubmitContainer>
        </PostcodeRow>
      </form>
    </Card>
  );
}

export default PostcodeCard;
